import { AuthState } from './types/auth.types';
import { GetterTree } from 'vuex';
import { RootState } from '@/store/store';

export const authGetters: GetterTree<AuthState, RootState> = {
  getUserPermissions: (state: AuthState) => {
    return state.roles;
  },
};
